import * as modelsGet from "../models/get";
import { getDenominations } from "../api/denominations";

var denominations: modelsGet.IDenomination[];

/**
 * Gibt alle Konfessionen zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getDenominationsAsync(reload: boolean = false): Promise<modelsGet.IDenomination[]>
{
    if (denominations == null || reload)
    {
        denominations = await getDenominations();
    }

    return denominations;
}